import {
  BooleanInput,
  Create,
  Edit,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

const StateFormFields = () => (
  <>
    <TextInput source="name" fullWidth validate={(value) => (!value ? 'Name is required' : undefined)} />
    <TextInput source="slug" fullWidth helperText="Leave blank to auto-generate from name" />
    <ReferenceInput source="country_id" reference="countries" label="Country">
      <SelectInput optionText="name" validate={(value) => (!value ? 'Country is required' : undefined)} />
    </ReferenceInput>
    <BooleanInput source="is_active" label="Active" defaultValue />
  </>
);

export function StateEdit() {
  return (
    <Edit>
      <SimpleForm>
        <StateFormFields />
      </SimpleForm>
    </Edit>
  );
}

export function StateCreate() {
  return (
    <Create redirect="list">
      <SimpleForm defaultValues={{ is_active: true }}>
        <StateFormFields />
      </SimpleForm>
    </Create>
  );
}
